/* eslint-disable @typescript-eslint/no-empty-interface */
import {
  Privacy,
  PRIVACY_PUBLIC,
  PRIVACY_PASSWORD,
  PRIVACY_UNLISTED,
  PRIVACY_DISABLE,
  PRIVACY_USER,
  PRIVACY_FOLLOW,
} from '../constants';

/**
 * QoL improvement only
 * For some reason, redefine an interface will make VScode intellenisense working better ---
 * when hover on method, it will show the actual type values instead of just a type name alias "VideoPrivacy"
 */
export interface PrivacyTypes extends Privacy {}
export type VideoPrivacy = PrivacyTypes['view'];

export class PrivacyUtility {
  /**
   * Public facing privacy values include "Public", "Password", and legacy privacies "People I follow", "People I choose", where the underlining privacy is public.
   * Normally it describe videos that's intended for public facing purpose.
   *
   * It's the reverse of non-public videos, "unlisted", "hide from video", and "private" privacy videos, those are intended for internal purpose
   */
  static isPublicFacingPrivacy(privacy: VideoPrivacy) {
    return [PRIVACY_PUBLIC, PRIVACY_PASSWORD, PRIVACY_USER, PRIVACY_FOLLOW].includes(privacy);
  }

  /**
   * Internal facing privacy values include all other privacy values that's not "Public", "Password", "People I follow", and "People I choose".
   * It's the reverse of public facing videos, for videos that's intended for internal purpose.
   */
  static isInternalFacingPrivacy(privacy: VideoPrivacy) {
    return !PrivacyUtility.isPublicFacingPrivacy(privacy);
  }

  /**
   * Whether a giving value matches the target privacy value
   */
  static isPrivacyMatch(privacy: VideoPrivacy | string | undefined, targetPrivacy: VideoPrivacy) {
    return privacy === targetPrivacy;
  }

  static isPublicPrivacy(privacy: VideoPrivacy | undefined) {
    return this.isPrivacyMatch(privacy, PRIVACY_PUBLIC);
  }

  static isUnlistedPrivacy(privacy: VideoPrivacy | undefined) {
    return this.isPrivacyMatch(privacy, PRIVACY_UNLISTED);
  }

  static isPasswordPrivacy(privacy: VideoPrivacy | undefined) {
    return this.isPrivacyMatch(privacy, PRIVACY_PASSWORD);
  }

  static isHideFromVimeoPrivacy(privacy: VideoPrivacy | undefined) {
    return this.isPrivacyMatch(privacy, PRIVACY_DISABLE);
  }
}
